// It's an implementation of .number modifier in case, when v-model.number can't be used
// example extracting common inputs from inline version to encapsulated component
// https://github.com/vuejs/vue/blob/bed04a77e575d6c4c1d903f60087dca874f7213e/src/shared/util.ts#L109
// eslint-disable-next-line import/prefer-default-export
export function toNumber(val) {
  const n = parseFloat(val);
  return Number.isNaN(n) ? val : n;
}
